import { useState, useEffect } from 'react';
import style from './mainpage.module.scss';
import Guess from '../components/logic/guess';
import Qwerty from '../components/logic/qwert';
import WordsWordle from '../data/guessWords.json';
import { useRef } from "react";
import { useNavigate } from "react-router-dom";


import { ValidateWord, ValidateLength, ValidateEqualWords } from '../components/logic/wordvalidate';

export default function Home() {
    const words = WordsWordle;
    const [position, setPosition] = useState({ top: 800, left: 530 });
    const [count, setCount] = useState(0);
    const navigate = useNavigate();
    const valentineMessage = ["WILL", "YOU", "BE", "MY", "VALENTINE", "?"];
    const wordLengths = valentineMessage.map(word => word.trim().length);
    const testChange = "nice";



    //Load local storage or loadDefault
    const firstGuessBoxRef = useRef(null);
    const dropdownRef = useRef(null);
    const [showValentineMessage, setShowValentineMessage] = useState(() => {
        return sessionStorage.getItem("showValentine") === "true";
    });

    const [currentRow, setCurrentRow] = useState(() => {
        return parseInt(localStorage.getItem('currentRow')) || 0;
    })

    const [guesses, setGuesses] = useState(() => {
        return JSON.parse(localStorage.getItem('guesses')) || Array(6).fill('');
    })

    const [isGuessed, setIsGuessed] = useState(() => {
        return JSON.parse(localStorage.getItem('isGuessed')) || Array(6).fill(false);
    })

    const [wordIndex, setWordIndex] = useState(() => {
        return parseInt(localStorage.getItem('wordIndex')) || 0;
    })

    const [showNextButton, setShowNextButton] = useState(() => {
        return JSON.parse(localStorage.getItem('showNextButton') || 'false');
    });


    const [showError, setShowError] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState('');
    const [isShaking, setIsShacking] = useState(Array(6).fill(false));
    const [isVisibleLine, setIsVisibleLines] = useState([]);
    const [handleResetQwerty, setHandleResetQwerty ] = useState(false);
    const [isDropDownOpen, setIsDropDownOpen] = useState(false);
    

    useEffect(() => {
        setIsVisibleLines([]);
        if (count === 3) {
            let delay = 0;

            const timeoutIds = guesses.map((_, i) => {
                setTimeout(() => {
                    setIsVisibleLines((prev) => [...prev, i])
                }, delay);

                delay += guesses[i].length * 100;
                console.log(guesses[i].length)

            });

            return () => timeoutIds.forEach(id => clearTimeout(id));
        } else {
            setIsVisibleLines(guesses.map((_, i) => i));
        }
         
    }, [count])


    useEffect(() => {
        setWordIndex(0);
        setCurrentRow(0);
        setIsGuessed(Array(6).fill(false)); // Reset state properly
        setGuesses(Array(6).fill(''));
        setShowNextButton(false);
        window.sessionStorage.clear();
      }, []);

    useEffect(() => {
        localStorage.setItem('wordIndex', wordIndex);
        localStorage.setItem('currentRow', currentRow);
        localStorage.setItem('guesses', JSON.stringify(guesses));
        localStorage.setItem('isGuessed', JSON.stringify(isGuessed));
        localStorage.setItem('showNextButton', showNextButton);
    }, [wordIndex, currentRow, guesses, isGuessed, showNextButton]);


    const handleNextTestWord = () => {
        setWordIndex((prev) => prev < words.length - 1 ? prev + 1 : 0);
        setCurrentRow(0);
        setIsGuessed(Array(6).fill(false)); // Reset state properly
        setGuesses(Array(6).fill(''));
        setShowNextButton(false);
        localStorage.removeItem('currentRow');
        localStorage.removeItem('guesses');
        localStorage.removeItem('isGuessed');
        localStorage.removeItem('showNextButton');

        setHandleResetQwerty(true);

        if (count === 3) {
            setCount(4)
        }

        setTimeout(() => {
            firstGuessBoxRef.current?.focus();
        }, 0);

    };

    const handlePreviousTestWord = () => {
        setWordIndex((prev) => prev > 0 ? prev - 1: words.length -1);
        setCurrentRow(0);
        setIsGuessed(Array(6).fill(false)); // Reset state properly
        setGuesses(Array(6).fill(''));
        setShowNextButton(false);
        localStorage.removeItem('currentRow');
        localStorage.removeItem('guesses');
        localStorage.removeItem('isGuessed');
        localStorage.removeItem('showNextButton');

        setHandleResetQwerty(true);
        if (count === 3) {
            setCount(4)
        }

        setTimeout(() => {
            firstGuessBoxRef.current?.focus();
        }, 0);
    }


    const handleChooseTestWord = (index) => {
        setWordIndex(index);
        setCurrentRow(0);
        setIsGuessed(Array(6).fill(false));
        setGuesses(Array(6).fill(false));
        setShowNextButton(false);
        localStorage.removeItem('currentRow');
        localStorage.removeItem('guesses');
        localStorage.removeItem('isGuessed');
        localStorage.removeItem('showNextButton');

        setIsDropDownOpen(prev => !prev)

        setHandleResetQwerty(true);
        if (count === 3) {
            setCount(4)
        }

        setTimeout(() => {
            firstGuessBoxRef.current?.focus();
        }, 0);

    }

    const handleKeyPress = (e) => {

        if (currentRow >= 6) return; 

        const newGuess = [...guesses];
        
        if (e.key === "Enter") {
            console.log(words[wordIndex].word);
            
            if (!ValidateLength(newGuess[currentRow])) {
                triggerShake();
                setErrorMessage('Not enough letters');
                setShowError(true);
                setTimeout(() => setShowError(false), 1500);
                return;
            } else if (!ValidateWord(newGuess[currentRow])) {
                triggerShake();
                setErrorMessage('Not A Valid Word')
                setShowError(true);
                setTimeout(() => setShowError(false), 1500);
                return;
            } else if (newGuess[currentRow].toLowerCase() === words[wordIndex].word.toLowerCase()) {
                if (count < 4) {
                    setCount((prev) => prev + 1);
                }    
                setIsGuessed((prev) => {
                    const updated = [...prev];
                    updated[currentRow] = true;
                    return updated;
                })
            } else if (newGuess[currentRow].length === 5) {
                setIsGuessed((prev) => {
                    const updated = [...prev];
                    updated[currentRow] = true;
                    return updated;
                });
                if (currentRow < 5) {
                    setCurrentRow((prev) => prev + 1);
                }
            }
        } else if (/^[a-zA-Z]$/.test(e.key) && newGuess[currentRow].length < 5) {
            newGuess[currentRow] += e.key.toLowerCase();
            setGuesses([...newGuess]); 
        } else if (e.key === "Backspace" && newGuess[currentRow].length > 0) {
            newGuess[currentRow] = newGuess[currentRow].slice(0, -1);
            setGuesses([...newGuess]); 
        }
    };


    const triggerShake = () => {
        setIsShacking((prev) => {
            const updated = [...prev];
            updated[currentRow] = true;
            return updated;
        })

        setTimeout(() => {
            setIsShacking((prev) => {
                const updated = [...prev];
                updated[currentRow] = false;
                return updated;
            })
        }, 500)
    }



    const handleMouseMove = (event) => {
        const button = event.target.getBoundingClientRect();
        const mouseX = event.clientX;
        const mouseY = event.clientY;
        const buttonX = button.left + button.width / 2;
        const buttonY = button.top + button.height / 2;

        const deltaX = buttonX - mouseX;
        const deltaY = buttonY - mouseY;
        const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);

        if (distance < 80) { // Moves away when cursor gets too close
            const moveX = deltaX / distance * 40;
            const moveY = deltaY / distance * 40;

            setPosition((prev) => ({
                top: Math.max(0, Math.min(window.innerHeight - button.height, prev.top + moveY)),
                left: Math.max(0, Math.min(window.innerWidth - button.width, prev.left + moveX)),
            }));
        }
    };

    const handleRedirect = () => {
        navigate('/SecretPage')
    }

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropDownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (count === 3 && !showValentineMessage) {
            setGuesses(valentineMessage);
            setShowValentineMessage(true);
            setShowNextButton(true);
            sessionStorage.setItem("showValentine", "true");
        }
    }, [count, showValentineMessage]);

    
    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, [currentRow, guesses]); // Add dependencies

    return (
        <div className={style.MainPageContainer}>
            <p className={style.WordleNumber}>Wordle #{words[wordIndex].id}</p>
            <div className={style.ButtonsMovement}>
                <button 
                className={style.NextButton} 
                onClick={handlePreviousTestWord}
                onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                >
                    Previous
                </button>
                <div className={style.ChooseButtonContainer} ref={dropdownRef}>
                    <button 
                        className={style.ChooseButton} 
                        onClick={() => setIsDropDownOpen(prev => !prev)}
                    >
                        Choose
                    </button>
                    {isDropDownOpen && (
                        <ul className={`${style.Dropdown} ${isDropDownOpen ? style.Open : ''}`}>
                        {words.map((word, index) => (
                            <li className={style.ListElements} key={word.id} onClick={() => handleChooseTestWord(index)}>
                                {`#${word.id}`}
                            </li>
                        ))}
                        </ul>
                        )
                    }
                    
                </div>
                <button 
                className={style.NextButton} 
                onClick={handleNextTestWord}
                onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                >
                    Next
                </button>
            </div>
            <div className={`${style.ErrorMessageContainer} ${showError ? style.show : ''}`}>
                <p className={style.ErrorMessage}>{ErrorMessage}</p>
            </div>
            {guesses.map((guess, i) => (
                isVisibleLine.includes(i) && (
                    <Guess 
                    key={i} 
                    word={words[wordIndex].word.toLowerCase()} 
                    guess={guess} 
                    isGuessed={isGuessed[i]} 
                    isShaking={isShaking[i]}
                    ref={i === 0 ? firstGuessBoxRef : null}
                    wordLengths={wordLengths[i]}
                    count={count}
                    />
                )
            ))}
             {showNextButton && (
                <div className={style.SecretButtons}> 
                    <button className={style.NoButton} 
                    style={{ top: position.top, left: position.left }}
                    onMouseMove={handleMouseMove}
                    >No</button>
                    <div className={style.YesButton} onClick={handleRedirect}>
                        <p className={style.YesText}>Yes</p>
                    </div>
                    
                </div>
            )}
            <Qwerty 
                guess={guesses[currentRow - 1] || ''} 
                word={words[wordIndex].word.toLowerCase()} 
                onKeyPress={handleKeyPress}
                isGuessed={isGuessed[currentRow - 1]}
                handleResetQwerty={handleResetQwerty}
                setHandleResetQwerty={setHandleResetQwerty}
            />    
        </div>
    );
}